import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please provide a first name' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a last name' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'required', message: 'Please provide a phone number' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    theme: {
      validations: [
        { type: 'required', message: 'Please provide an event type' },
      ]
    },
    plannedguestcount: {
      validations: []
    },
    eventDate: {
      validations: [
        { type: 'required', message: 'Please provide an event date' },
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    Reference: {
        validations: []
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'FIRST NAME:*',
            mapping: 'firstName'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'LAST NAME:*',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'EMAIL ADDRESS:*',
            mapping: 'email'
      },
      {
            type: 'text',
            size: 'Medium',
            label: 'PHONE:*',
            mapping: 'telNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'PREFERRED DATE OF EVENT:*',
            mapping: 'eventDate'
      },
      {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'TYPE OF EVENT:*',
            options: [
              { label: 'Wedding', value: 'Wedding'},
              { label: 'Rehearsal', value: 'Rehearsal' },
              { label: 'Corporate Event', value: 'Corporate Event' },
              { label: 'Birthday', value: 'Birthday' },
              { label: 'Anniversary', value: 'Anniversary' },
              { label: 'Holiday Party', value: 'Holiday Party' },
              { label: 'Celebration of Life', value: 'Celebration of Life' },
              { label: 'Bar Mitzvah', value: 'Bar Mitzvah' },
              { label: 'Quinceanea', value: 'Quinceanea' },
              { label: 'Shower', value: 'Shower' },
          ],
            mapping: 'theme'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'NUMBER OF GUESTS:',
            mapping: 'plannedguestcount'
      },
      {

            type: 'multiple-choice',
            size: 'Medium',
            label: 'HOW DID YOU HEAR ABOUT US?:',
            options: [
              { label: 'Saskatoon Customer', value: 'Saskatoon Customer'},
              { label: 'Hosted with you before', value: 'Hosted with you before' },
              { label: 'Google', value: 'Google' },
              { label: 'Radio', value: 'Radio' },
              { label: 'Family/Friend', value: 'Family/Friend' },
              { label: 'Referral', value: 'Referral' },
              { label: 'Newspaper', value: 'Newspaper' },
              { label: 'Magazine', value: 'Magazine' },
              { label: 'Billboard', value: 'Billboard' },
              { label: 'Hotel', value: 'Hotel' },
              { label: 'Other', value: 'Other' },
          ],
            mapping: 'Reference'
        }
      ]
    },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'ADDITIONAL COMMENTS/QUESTIONS:',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'SEND ME FULL DETAILS'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Saskatoon Lodge Contact Form',
    formId: '826',
    clientKey: 'E41D7692-2B9B-48C5-878C-5A8C23F6E242',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
